// @ts-nocheck
import Typography from "@insite/mobius/Typography";
import React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import CarLine from "@store/Library/Components/Toolkit/Icons/Car/CarLine";
import CheckmarkCircle2Line from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Line";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertTriangleLine from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleLine";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import getColor from "@insite/mobius/utilities/getColor";

export type BannerVariant = "success" | "warning";

interface CartBannerProps {
    label: string;
    variant: BannerVariant;
}

export interface CartBannerStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    carIcon?: IconPresentationProps;
}

export const cartBannerStyles: CartBannerStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: stretch;
            width: 100%;
            border-radius: 5px;
            overflow: hidden;
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(8)};
            padding: ${pxToRem(20)} ${pxToRem(10)};
        `,
    },
    carIcon: {
        src: CarLine,
        color: "primary.contrast",
    },
};

const styles = cartBannerStyles;

export const cartBannerTypes = {
    warning: {
        color: "warning",
        backgroundColor: "warning.light",
        icon: {
            src: AlertTriangleLine,
        },
    },
    success: {
        color: "success",
        backgroundColor: "success.light",
        icon: {
            src: CheckmarkCircle2Line,
        },
    },
};

const CartBanner = ({ label, variant }: CartBannerProps) => {
    const { color, backgroundColor, icon } = cartBannerTypes[variant];

    const iconInnerWrapperStyles = React.useMemo(() => {
        return mergeProps<CartBannerStyles["innerWrapper"]>(styles.innerWrapper, {
            css: css`
                background-color: ${getColor(color)};
            `,
        });
    }, [styles.innerWrapper, color]);

    const mainInnerWrapperStyles = React.useMemo(() => {
        return mergeProps<CartBannerStyles["innerWrapper"]>(styles.innerWrapper, {
            css: css`
                flex: 1;
                background-color: ${getColor(backgroundColor)};
            `,
        });
    }, [styles.innerWrapper, backgroundColor]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...iconInnerWrapperStyles}>
                <Icon {...styles.carIcon} />
            </StyledWrapper>
            <StyledWrapper {...mainInnerWrapperStyles}>
                <Icon src={icon.src} color={color} />
                <Typography>{label}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CartBanner;
